import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import { SWAL_SETTINGS, PHONE_NO_LENGTH, INPUT_MAX_25, TEXTAREA_MAX_LENGTH, GENDER, ROLE } from "../../../../utils/Constants";
import {
    handleServerValidations,
    DT,
    globalLoader,
    capitalizeFirstLetter
} from "../../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../../utils/customError";
import { useTranslation } from "react-i18next";
import { DatePicker, Tooltip, Whisper } from "rsuite";
import PhoneInput from "../../../../utils/PhoneInput";
import { PHONE_VALIDATION } from "../../../../utils/commonValidations";
// import { detail, edit } from "../../../doctor/services/patient.services";
import { GetAllCenters, GetAllCentersWithDoctor } from "../../services/usermgmt.services";
import { allDoctors } from "../../services/doctor.services";
import Select from 'react-select';
import { Details, Edit } from "../../.../../services/customer.services"


const CustomerEdit = (props) => {
    const navigate = useNavigate();
    const params = useParams();
    const { t } = useTranslation();
    const [showdefault, setShowDefault] = useState({});
    const [previewimage, setPreviewImage] = useState("");
    const [saveType, setSaveType] = useState("");
    const [centers, setCenters] = useState([]);
    const [doctors, setDoctors] = useState([]);

    const breadcrumbs = [
        { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
        {
            title: t("Customer Management"),
            url: "/admin/customer-management/customer/list/1",
        },
        { title: t("admin.cafes.link_edit"), url: "" },
    ];

    useEffect(() => {
        Details(params.id)
            .then((response) => {
                setShowDefault(response && response.data ? response.data : []);
            })
            .catch((error) => {
                console.log("error=====>", error);
            });
    }, [params.id]);


    useEffect(() => {
        GetAllCenters()
            .then((data) => {
                setCenters(data && data.data ? data.data : []);
            })
            .catch((error) => {
                console.log("error ====> ", error);
            });
    }, []);

    const centerOptions = centers.map((item) => ({
        value: item._id,
        label: `${capitalizeFirstLetter(item.center_name)}${item.city ? ` (${capitalizeFirstLetter(item.city)})` : ''}`
    }));

    const validationSchema = Yup.object().shape({
        first_name: Yup.string().trim()
            .min(3, "Customer first name must be at least 3 characters.")
            .max(30, "Customer first name must not be more than 30 characters.")
            .matches(/^[a-zA-Z\s&\-'.]+$/, "Customer first name can only contain letters, spaces, and common punctuation.")
            .required("Customer first name is required"),
            last_name: Yup.string().trim()
            .min(3, "Customer last name must be at least 3 characters.")
            .max(30, "Customer last name must not be more than 30 characters.")
            .matches(/^[a-zA-Z\s&\-'.]+$/, "Customer last name can only contain letters, spaces, and common punctuation.")
            .required("Customer last name is required"),
        email: Yup.string()
            .trim()
            .email("admin.cafes.label_email_invalid_format_error")
            .matches(
                /^(?!\.)(?!.*\.\.)[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
                "admin.cafes.label_email_invalid_format_error"
            ),
        phone_number: PHONE_VALIDATION,
        gender: Yup.string().required("Gender is required"),
        dob: Yup.date().required("DOB is required"),
        language_preference: Yup.string()
        .matches(/^[a-zA-Z\s&\-'.]+$/, "Language preference can only contain letters, spaces, and common punctuation.")
        .required("Language preference is required"),
        address: Yup.string().trim().max(TEXTAREA_MAX_LENGTH, "Location must not be more than 150 characters.").required("Location is required"),
        // center: Yup.string()
        //     .trim()
        //     .required("Center is required"),
    });

    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            first_name: showdefault && showdefault.first_name ? showdefault.first_name : "",
            last_name: showdefault && showdefault.last_name ? showdefault.last_name : "",
            email: showdefault && showdefault.email ? showdefault.email : "",
            phone_number: showdefault && showdefault?.phone_number ? showdefault?.phone_number : "",
            address: showdefault && showdefault.address ? showdefault.address : "",
            dob: showdefault && showdefault.dob ? showdefault.dob : "",
            gender: showdefault && showdefault.gender ? showdefault.gender : "",
            language_preference: showdefault && showdefault.language_preference ? showdefault.language_preference : "",
            wellness_club_id: showdefault && showdefault.wellness_club_id ? showdefault.wellness_club_id : "",
            // center: showdefault?.center_ids?.[0] ?? ""
        },
        validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting, resetForm }) => {
            globalLoader(true);
            let formData = new FormData();
            formData.append("o_id", params.id);
            formData.append("first_name", values.first_name);
            formData.append("last_name", values.last_name);
            formData.append("email", values.email.toLowerCase());
            formData.append("phone_number", values.phone_number);
            formData.append("dob", values.dob);
            formData.append("gender", values.gender);
            formData.append("language_preference", values.language_preference);
            formData.append("address", values.address);
            // formData.append("center_id", values.center);
            Edit(formData)
                .then((response) => {
                    setSubmitting(false);
                    if (response.success) {
                        Swal.fire({
                            icon: "success",
                            text: response.message,
                            ...SWAL_SETTINGS,
                        });
                        globalLoader(false);
                        if (saveType !== "Save") {
                            navigate(`/admin/customer-management/customer/list/1`);
                        }
                    } else {
                        Swal.fire({
                            icon: "error",
                            text: handleServerValidations(response),
                            ...SWAL_SETTINGS,
                        });
                    }
                    globalLoader(false);
                })
                .catch((error) => {
                    Swal.fire({
                        icon: "error",
                        text: handleServerValidations(error),
                        ...SWAL_SETTINGS,
                    });
                    console.log("error ====> ", error);
                });
        },
    });
    return (
        <>
            <Breadcrums data={breadcrumbs} />
            <form onSubmit={formik.handleSubmit}>
                <div className="row row-sm">
                    <div className="col-lg-12 col-md-12 animation_fade">
                        <div className="card custom-card">
                            <div className="card-body">
                                <div>
                                    <h6 className="main-content-label mb-3">
                                        {t("Edit Customer")}
                                    </h6>
                                </div>
                                <div className="row row-sm">

                                    <div className="col-md-6 text-center form-group">
                                        <label htmlFor="first_name" className="text-left d-flex">
                                            {t("Customer First Name")}:
                                            <span className="requirestar">*</span>{" "}
                                        </label>
                                        <input
                                            name="first_name"
                                            id="first_name"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.first_name}
                                            className="form-control"
                                            placeholder={t("Enter customer first name")}
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="first_name" form={formik} />
                                        </span>
                                    </div>
                                    <div className="col-md-6 text-center form-group">
                                        <label htmlFor="last_name" className="text-left d-flex">
                                            {t("Customer Last Name")}:
                                            <span className="requirestar">*</span>{" "}
                                        </label>
                                        <input
                                            name="last_name"
                                            id="last_name"
                                            type="text"
                                            onChange={formik.handleChange}                                           
                                            onBlur={formik.handleBlur}
                                            value={formik.values.last_name}
                                            className="form-control"
                                            placeholder={t("Enter customer last name")}
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="last_name" form={formik} />
                                        </span>
                                    </div>
                                    
                                    <div className="col-lg-6 text-center form-group">
                                        <label htmlFor="email" className="text-left d-flex">
                                            {t("admin.cafes.label_email")}:
                                        </label>
                                        <input
                                            name="email"
                                            id="email"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.email}
                                            className="form-control"
                                            placeholder={t("admin.cafes.placeholder_email")}
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="email" form={formik} />
                                        </span>
                                    </div>
                                    <div className="col-md-6 text-center form-group">
                                        <label className="text-left d-flex" htmlFor="phone_number">
                                            {t("admin.cafes.label_phone_number")}:
                                            <span className="requirestar">*</span>{" "}
                                        </label>
                                        <PhoneInput
                                            name="phone_number"
                                            id="phone_number"
                                            placeholder={t('admin.cafes.placeholder_phone_number')}
                                            onChange={(e) => { formik.setFieldValue('phone_number', e?.phone_number) }}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.phone_number}
                                            className="form-control"
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="phone_number" form={formik} shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                                        </span>
                                    </div>
                                    <div className="col-md-6 text-center form-group">
                                        <label className="text-left d-flex">
                                            {t("Gender")}:
                                            <span className="requirestar">*</span>
                                        </label>
                                        <select className="form-control form-select cp" name='gender' value={formik?.values?.gender} onChange={formik.handleChange}>
                                            <option value={""}>{t("Select")}</option>
                                            {GENDER.map((item, index) => { return (<option key={index} value={item.value}>{item.label}</option>) })}
                                        </select>
                                        {formik.touched.gender && formik.errors.gender ? (
                                            <div className="text-danger d-flex text-left">{t(formik.errors.gender)}</div>
                                        ) : null}
                                    </div>
                                    {/* dob */}
                                    <div className="col-lg-6 text-center form-group">
                                        <label className="text-left d-flex">
                                            {t("DOB")}:
                                            <span className="requirestar">*</span>
                                        </label>
                                        <DatePicker
                                            oneTap={true}
                                            classPrefix="restaurant"
                                            placeholder={t("Enter DOB")}
                                            placement="autoVertical"
                                            format="dd.MM.yyyy"
                                            cleanable={false}
                                            editable={false}
                                            name="dob"
                                            onChange={(e) => {
                                                formik.setFieldTouched('dob', true);
                                                formik.setFieldValue("dob", e);
                                            }}
                                            value={new Date(formik.values.dob) || new Date()}
                                            onBlur={formik.handleBlur}
                                            shouldDisableDate={(date) => {
                                                const today = new Date();
                                                today.setHours(0, 0, 0, 0);

                                                const minDate = new Date();
                                                minDate.setFullYear(today.getFullYear() - 18);
                                                minDate.setHours(0, 0, 0, 0);

                                                return date >= minDate
                                            }}
                                            onOpen={() => {
                                                const today = new Date();
                                                const minDate = new Date();
                                                minDate.setFullYear(today.getFullYear() - 18);

                                                if (!formik.values.dob) {
                                                    formik.setFieldValue("dob", minDate);
                                                }
                                            }}
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="dob" form={formik} />
                                        </span>
                                    </div>
                                    <div className="col-md-6 text-center form-group">
                                        <label htmlFor="address" className="text-left d-flex">
                                            {t("Location")}:
                                            <span className="requirestar">*</span>{" "}
                                        </label>
                                        <input
                                            name="address"
                                            id="address"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.address}
                                            className="form-control"
                                            placeholder={t("Enter location")}
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError shortCodes={[TEXTAREA_MAX_LENGTH]} name="address" form={formik} />
                                        </span>
                                    </div>

                                    <div className="col-md-6 text-center form-group">
                                        <label htmlFor="name" className="text-left d-flex">
                                            {t("Language Preference")}:
                                            <span className="requirestar">*</span>{" "}
                                        </label>
                                        <input
                                            name="language_preference"
                                            id="language_preference"
                                            type="text"
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            value={formik.values.language_preference}
                                            className="form-control"
                                            placeholder={t("Enter language preference")}
                                        />
                                        <span className="text-danger d-flex text-left">
                                            <CustomError name="language_preference" form={formik} />
                                        </span>
                                    </div>

                                    {
                                        formik.values.wellness_club_id
                                        &&
                                        <div className="col-md-6 text-center form-group">
                                            <label htmlFor="name" className="text-left d-flex">
                                                Wellness Clud Id
                                            </label>
                                            <input
                                                name="wellness_club_id"
                                                id="wellness_club_id"
                                                type="text"
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                value={formik.values.wellness_club_id}
                                                className="form-control"
                                                disabled
                                                // placeholder={t("Enter language preference")}
                                            />
                                        </div>
                                    }
                                    {/*
                                    <div className="col-md-6 text-center form-group">
                                        <label className="text-left d-flex">
                                            Center:
                                            <span className="requirestar">*</span>
                                        </label>

                                        <Select
                                            className="cp"
                                            name="center"
                                            options={centerOptions}
                                            value={centerOptions.find(option => option.value === formik.values.center)}
                                            onChange={selectedOption => formik.setFieldValue('center', selectedOption?.value)}
                                            onBlur={() => formik.setFieldTouched('center', true)}
                                            placeholder={t("Select")}
                                            isSearchable={true}
                                            noOptionsMessage={() => t("No centers found")}
                                        />

                                        {formik.touched.center && formik.errors.center ? (
                                            <div className="text-danger d-flex text-left">{t(formik.errors.center)}</div>
                                        ) : null}
                                    </div>*/}
                                    <div className="mt-5">
                                        <button
                                            onClick={() => {
                                                setSaveType("Save");
                                            }}
                                            className="btn btn-info mr-2"
                                            type="submit"
                                        >
                                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                            {t("admin.button.btn_save")}
                                        </button>
                                        <button
                                            onClick={() => {
                                                setSaveType("");
                                            }}
                                            className="btn btn-success mr-2"
                                            type="submit"
                                        >
                                            <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                                            {t("admin.button.btn_save_exit")}
                                        </button>
                                        <button
                                            className="btn ripple btn-secondary"
                                            type="button"
                                            onClick={() => navigate(-1)}
                                        >
                                            <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                                            {t("admin.button.btn_cancel")}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </>
    );
};

export default CustomerEdit;